var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.isLoggedIn)?_c('side-bar'):_vm._e(),(_vm.isLoggedIn)?_c('v-app-bar',{attrs:{"app":"","elevation":"1"}},[_c('v-toolbar-title',{staticClass:"text--disabled"},[_vm._v("Edit Page")])],1):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }